import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import PropTypes from 'prop-types';
import React from 'react';
import '../../index.scss';
import { priorityCells, shouldShowCell } from '../../TableCellGenerator';

const UsersTableHead = ({ venue }) => {
  return (
    <TableHead>
      <TableRow>
        {priorityCells.map(cell => {
          return shouldShowCell(cell, venue) ? (
            <TableCell
              key={`${venue.id}${cell.className}`}
              className={cell.className}
            >
              {cell.title}
            </TableCell>
          ) : null;
        })}
      </TableRow>
    </TableHead>
  );
};

UsersTableHead.propTypes = {
  venue: PropTypes.object.isRequired,
};

export default UsersTableHead;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/Users/ViewUsersPanel/UsersTable/UsersTableHead/index.jsx